<template>
  <div class="party-topic-panel">
    <template v-if="isDetail">
      <article v-if="front.activePartyTopic" class="party-topic-detail">
        <h2 class="party-topic-detail-title">{{ front.activePartyTopic.title }}</h2>
        <p v-if="front.activePartyTopic.summary" class="party-topic-detail-summary">
          {{ front.activePartyTopic.summary }}
        </p>
        <div
          v-if="front.activePartyTopic.bodyContent"
          class="rich-body"
          v-html="front.activePartyTopic.bodyContent"
        />
        <div v-if="front.entryAttachments(front.activePartyTopic).length" class="party-topic-files">
          <button
            v-for="(file, index) in front.entryAttachments(front.activePartyTopic)"
            :key="file.id || file.url || index"
            type="button"
            class="party-file-link"
            @click="front.downloadEntryAttachment(front.activePartyTopic, file)"
          >
            {{ front.attachmentLabel(file, index, front.entryAttachments(front.activePartyTopic).length) }}
          </button>
        </div>
        <div class="topic-list party-topic-list">
          <button
            v-for="item in front.activePartyTopicArticles"
            :key="item.entryId || item.title"
            type="button"
            @click="front.openPartyEntry(item)"
          >
            <strong>{{ item.title }}</strong>
            <span>{{ item.summary || item.date || '暂无摘要' }}</span>
          </button>
          <p v-if="!front.activePartyTopicArticles.length" class="muted-copy">暂无关联文章</p>
        </div>
      </article>
      <p v-else class="muted-copy">暂无已发布内容，请在管理后台维护</p>
    </template>
    <template v-else>
      <div class="party-card-grid">
        <div
          v-for="item in front.partyListItems"
          :key="item.entryId || item.title"
          class="party-media-card-item"
        >
          <button
            type="button"
            class="party-media-card"
            @click="openTopic(item)"
          >
            <div
              class="party-media-card-cover"
              :style="coverStyle(item)"
              aria-hidden="true"
            />
            <div class="party-media-card-body">
              <strong>{{ item.title }}</strong>
              <span>{{ item.summary || item.date || '暂无摘要' }}</span>
            </div>
          </button>
          <div v-if="front.entryAttachments(item).length" class="party-card-files">
            <button
              v-for="(file, index) in front.entryAttachments(item)"
              :key="file.id || file.url || index"
              type="button"
              class="party-file-link"
              @click="front.downloadEntryAttachment(item, file)"
            >
              {{ front.attachmentLabel(file, index, front.entryAttachments(item).length) }}
            </button>
          </div>
        </div>
        <p v-if="!front.partyListItems.length" class="muted-copy">暂无已发布内容，请在管理后台维护</p>
      </div>
      <FrontPagination
        :page-num="front.partyListPageNum"
        :page-size="front.partyListPageSize"
        :total="front.partyListTotal"
        @change="page => front.changePartyListPage(page)"
      />
    </template>
  </div>
</template>

<script>
import FrontPagination from '../common/FrontPagination.vue'

export default {
  name: 'PartyTopicPanel',
  components: { FrontPagination },
  inject: ['front'],
  computed: {
    isDetail() {
      return !!(this.$route.params && this.$route.params.entryId)
    }
  },
  methods: {
    openTopic(item) {
      if (!item || !item.entryId) return
      this.front.goPath(`/special-topics/${item.entryId}`)
    },
    coverStyle(item) {
      const raw = (item && (item.coverUrl || item.mediaUrl)) || ''
      const url = raw ? this.front.resolvePublicDisplayUrl(raw) : ''
      if (!url) {
        return { background: 'linear-gradient(135deg, #f5e6e8, #f0d5d9)' }
      }
      return {
        backgroundImage: `url(${url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }
    }
  }
}
</script>
